import React from 'react';
import { Layout, Tooltip } from '@axiom/ui';

export const MatchGridTalentFlagHeader = () => (
  <Layout horizontalGutter="4px" position="middle">
    Talent Flag
    <Tooltip name="TALENT_FLAG_TOOLTIP">
      Please reach out to the Talent Owner before proceeding.
    </Tooltip>
  </Layout>
);
